import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RequisitoMainComponent } from './requisito-main.component';
import { AuthGuard } from '../helpers/auth.guard';

const routes: Routes = [
    // { path: '', component: ProjetoListComponent },
    // { path: 'edit/:id', component: ProjetoStepperComponent },
    { path: 'create', component: RequisitoMainComponent, canActivate: [AuthGuard] }
    // { path: 'projeto-price/:id', component: ProjetoPriceComponent,
    //   children: [
    //     { path: 'projeto-price-list/:id', component: PriceRequisitoListComponent },
    //     { path: 'projeto-price-form/:id', component: PriceRequisitoFormComponent },
    //     { path: 'projeto-equipe/:id', component: PriceEquipeListComponent },
    //     { path: 'projeto-equipe-form/:id', component: PriceEquipeFormComponent },
    //   ]},
    // { path: 'projeto-price-list/:id', component: PriceRequisitoListComponent },
    // { path: 'projeto-price-form/:id', component: PriceRequisitoFormComponent },
    // { path: 'projeto-equipe/:id', component: PriceEquipeListComponent },
    // { path: 'projeto-equipe-form/:id', component: PriceEquipeFormComponent },

      // children: [
      //   { path: '', component: PriceRequisitoListComponent },
      //   { path: 'projeto-price-form/:id', component: PriceRequisitoFormComponent },
      //   { path: 'projeto-equipe/:id', component: PriceEquipeListComponent },
      //   { path: 'projeto-equipe-form/:id', component: PriceEquipeFormComponent },
      // ]
    // }
  ];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class RequisitoRoutes { }
